// import React, { useRef, useState } from 'react';
// // Import Swiper React components
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Link } from 'react-router-dom';


// import 'swiper/css';



// import { Autoplay } from 'swiper/modules';

// export const AdvertiseBanner = (props) => {
//     const advertiseBannerData = props.data || []
//     console.log("advertiseBannerData ---- ",advertiseBannerData)
//     return (
//         <>
//             <Swiper
//                 spaceBetween={30}
//                 centeredSlides={true}
//                 autoplay={{
//                     delay: 2500,
//                     disableOnInteraction: false,
//                 }}
//                 modules={[Autoplay]}
//                 className="mySwiper"
//             >
//                 <SwiperSlide>
//                     <div className="">
//                         <img src="assets/img/1760694265568.jpg" alt="education" className="img-fluid" />
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div className="">
//                         <img src="assets/img/1760694265568.jpg" alt="education" className="img-fluid" />
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div className="">
//                         <img src="assets/img/1760694265568.jpg" alt="education" className="img-fluid" />
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div className="">
//                         <img src="assets/img/1760694265568.jpg" alt="education" className="img-fluid" />
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div className="">
//                         <img src="assets/img/1760694265568.jpg" alt="education" className="img-fluid" />
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div className="">
//                         <img src="assets/img/1760694265568.jpg" alt="education" className="img-fluid" />
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div className="">
//                         <img src="assets/img/1760694265568.jpg" alt="education" className="img-fluid" />
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div className="">
//                         <img src="assets/img/1760694265568.jpg" alt="education" className="img-fluid" />
//                     </div>
//                 </SwiperSlide>
               

//             </Swiper>
//         </>
//     );
// }







// import React from 'react';
// // Import Swiper React components
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay } from 'swiper/modules';
// import 'swiper/css';

// // Fallback static slides
// const staticSlides = [
//   "assets/img/1760694265568.jpg",
//   "assets/img/1760694265569.jpg",
//   "assets/img/1760694265570.jpg"
// ];

// const AdvertiseBanner = ({ data = [] }) => {
//   // Use API data if available, else fallback static
//   console.log("data advertice banner : ",data)
//   const slidesData =
//     Array.isArray(data) && data.length > 0 && data[0].slides
//       ? data[0].slides[0].imageUrl
//       : staticSlides;
//   console.log("slidesData advertice banner : ",slidesData)
//   return (
//     <Swiper
//       spaceBetween={30}
//       centeredSlides={true}
//       autoplay={{
//         delay: 2500,
//         disableOnInteraction: false,
//       }}
//       modules={[Autoplay]}
//       className="mySwiper"
//     >
//       {slidesData.map((imgUrl, index) => (
//         <SwiperSlide key={index}>
//           <div className="d-flex justify-content-center align-items-center" style={{ height: "400px", overflow: "hidden" }}>
//             <img
//               src={imgUrl}
//               alt={`slide-${index}`}
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover", // ✅ important: fills the div, crops if needed
//               }}
//             />
//           </div>
//         </SwiperSlide>
//       ))}
//     </Swiper>
//   );
// };

// export default AdvertiseBanner;







import React, { useEffect, useState, memo } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

// 🔹 Static fallback data (matching DB structure)
const staticAdvertiseBanner = {
  _id: "692d9dd98021ee219249a840",
  // sectionTitle: "स्टार न्यूज नेटवर्क, ब्यूरो पन्ना/ पन्ना",
  // sectionSlug: "panna",
  // contactNumber: "1111111122",
  slides: [
    {
      _id: "692dbb5497ba0e7162a2e3fa",
      imageUrl: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1764604755/advertiseBanner/slides/np9qwvzzv3ro7gtie9jj.jpg",
      publicId: "advertiseBanner/slides/np9qwvzzv3ro7gtie9jj"
    },
    {
      _id: "692dbb5497ba0e7162a2e3fb",
      imageUrl: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1764511235/homeBanner/mainNews/f4avogdc2rhom45imaye.jpg",
      publicId: "advertiseBanner/slides/sample2"
    }
  ],
  createdAt: "2025-12-01T13:53:29.442Z",
  updatedAt: "2025-12-01T15:59:16.310Z",
  __v: 0
};

const AdvertiseBanner = memo(() => {
  const [bannerData, setBannerData] = useState(staticAdvertiseBanner);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/v1/users/get-advertise-banner`
        );
        console.log("Advertise banner API response:", res.data);
        const apiData = res?.data?.data;

        // Handle both array and single object response
        if (Array.isArray(apiData) && apiData.length > 0) {
          setBannerData(apiData[0]); // Use the first banner if array
        } else if (apiData && typeof apiData === 'object' && !Array.isArray(apiData)) {
          setBannerData(apiData); // Use the object directly
        } else {
          console.log("Using static fallback data");
          setBannerData(staticAdvertiseBanner);
        }
      } catch (error) {
        console.error("Advertise banner error:", error);
        setBannerData(staticAdvertiseBanner);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  // Loader
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "400px",
          width: "100%",
          background: "#f7f7f7",
        }}
      >
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  // Check if slides exist and have items
  const slides = bannerData?.slides || [];

  if (slides.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "400px",
          width: "100%",
          background: "#f7f7f7",
        }}
      >
        <p className="text-muted">No advertisement banners available</p>
      </div>
    );
  }

  return (
    <div className="advertise-banner-section">
      {/* Optional: Display section title */}
      {bannerData.sectionTitle && (
        <div className="container mb-3">
          <h5 className="text-center">{bannerData.sectionTitle}</h5>
        </div>
      )}

      <Swiper
        spaceBetween={20}
        centeredSlides={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={slides.length > 1} // Only loop if multiple slides
        modules={[Autoplay]}
        className="mySwiper"
        style={{ width: "100%", height: "400px" }}
      >
        {slides.map((slide, i) => (
          <SwiperSlide key={slide._id || i}>
            <div
              style={{
                height: "400px",
                width: "100%",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#f0f0f0",
              }}
            >
              <img
                src={slide.imageUrl}
                alt={`${bannerData.sectionTitle || "Advertise Banner"} ${i + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.target.src = "/assets/img/placeholder.jpg";
                  e.target.style.objectFit = "contain";
                }}
                loading="lazy"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Optional: Display contact number */}
      {bannerData.contactNumber && (
        <div className="container mt-2 text-center">
          <small className="text-muted">
            संपर्क: {bannerData.contactNumber}
          </small>
        </div>
      )}
    </div>
  );
});

AdvertiseBanner.displayName = "AdvertiseBanner";

export default AdvertiseBanner;
